const isProduction = process.env.NODE_ENV === 'production';
import { logMissingConfig } from '../utils/errorHandlers';

const DEV_EMAIL_JS_DEFAULTS = {
    serviceId: 'service_gh08tim',
    templateId: 'template_eopzp2t',
    publicKey: '5Q-HF9Jk8HW-0GZZg'
};

const resolveEmailJsValue = (envValue, devValue, keyName) => {
    if (envValue && envValue.trim()) {
        return envValue.trim();
    }

    if (!isProduction) {
        return devValue;
    }

    logMissingConfig('EmailJS', `REACT_APP_EMAILJS_${keyName.toUpperCase()}`, 'Please provide REACT_APP_EMAILJS_* environment variables.');
    return '';
};

export const EMAIL_JS_CONFIG = {
    serviceId: resolveEmailJsValue(process.env.REACT_APP_EMAILJS_SERVICE_ID, DEV_EMAIL_JS_DEFAULTS.serviceId, 'serviceId'),
    templateId: resolveEmailJsValue(process.env.REACT_APP_EMAILJS_TEMPLATE_ID, DEV_EMAIL_JS_DEFAULTS.templateId, 'templateId'),
    publicKey: resolveEmailJsValue(process.env.REACT_APP_EMAILJS_PUBLIC_KEY, DEV_EMAIL_JS_DEFAULTS.publicKey, 'publicKey')
};

export const CONTACT_INFO = {
    address: {
        name: 'KickerEck',
        street: 'Sendstraße 100-102',
        city: '44143 Dortmund'
    },
    generalEmail: 'kickereck@gmail.com',
    legalContact: {
        name: 'Sebastian Roekens',
        street: 'Philipp-Nicolai-Weg 16',
        city: '58313 Herdecke',
        phone: '+49 176/56061274',
        email: {
            display: 'sebastian.roekens@googlemail.com',
            mailto: 'sebastian.roekens@googlemail.de'
        }
    }
};

export const SOCIAL_LINKS = {
    FACEBOOK: 'https://www.facebook.com/Tischfussballverstrahlt',
    TWITTER: 'twitter.com',
    YOUTUBE: 'youtube.com'
};

export const SMOOTH_SCROLL_CONFIG = {
    speed: 1000,
    speedAsDuration: true
};
